module.exports = __webpack_public_path__ + "static/media/login_text.4cdabef5.png";